import { ChangeDetectionStrategy, Component, input, QueryList, signal, ViewChildren } from '@angular/core';
import { ApprovalFormItem, TextNodeType } from '@mwe/models';
import { ApprovalFormItemComponent } from './approval-form-item.component';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';

@Component({
  selector: 'mwe-approval-form',
  templateUrl: './approval-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BasicCardComponent, ApprovalFormItemComponent],
})
export class ApprovalFormComponent {
  // todo use new viewChildren signal when ng-mock (!version 14.15.1) is updated and viewChildren is compatibel with MockComponent
  @ViewChildren(ApprovalFormItemComponent) itemRefs: QueryList<ApprovalFormItemComponent>;

  items = input.required<ApprovalFormItem[]>();
  isDirty = signal<boolean>(false);
  headlineNodeType = input<TextNodeType>('h5');

  markDirty(): void {
    this.isDirty.set(true);
  }

  isFormItemChecked(id: string): boolean {
    return this.getFormItemRef(id)?.isChecked();
  }

  isValid(): boolean {
    const hasSomeInvalidFormItems = this.itemRefs?.some(ref => !ref.isValid());
    return !hasSomeInvalidFormItems;
  }

  private getFormItemRef(id: string): ApprovalFormItemComponent {
    return this.itemRefs.find(ref => ref.item().id === id);
  }
}
